import { useSnackbar, SnackbarOrigin } from 'notistack';
import { getErrorMessage, getErrorType, ErrorDisplayOptions } from '../utils/errorHandler';

export const useAlert = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = (
    message: string,
    variant?: 'default' | 'error' | 'success' | 'warning' | 'info',
    autoHideDuration?: number | null,
    anchorOrigin?: SnackbarOrigin
  ) => {
    enqueueSnackbar(
      message,
      {
        variant: variant,
        autoHideDuration: autoHideDuration || 5000,
        anchorOrigin: anchorOrigin
      },
    );
  }

  /**
   * Backend'den gelen hatayı işleyip snackbar olarak gösterir
   * @param error - Catch bloğundan gelen hata
   * @param options - Hata gösterim seçenekleri
   * @param variant - Snackbar variant'ı (otomatik belirlenir)
   * @param autoHideDuration - Otomatik kapanma süresi
   * @param anchorOrigin - Snackbar konumu
   */
  const showError = (
    error: any,
    options: ErrorDisplayOptions = {},
    variant?: 'default' | 'error' | 'success' | 'warning' | 'info',
    autoHideDuration?: number | null,
    anchorOrigin?: SnackbarOrigin
  ) => {
    const message = getErrorMessage(error, options);
    
    // Eğer variant belirtilmemişse, status code'a göre otomatik belirle
    let errorVariant = variant;
    if (!errorVariant && error && typeof error === 'object' && error.statusCode) {
      errorVariant = getErrorType(error.statusCode);
    } else if (!errorVariant) {
      errorVariant = 'error';
    }

    showSnackbar(message, errorVariant, autoHideDuration, anchorOrigin);
  }

  return { showSnackbar, showError };
};
